/**
 * helper/userAgent
 */


export function isUA(ua){
  const userAgent = window.navigator.userAgent.toLowerCase();
    if(userAgent.indexOf(ua) !== -1) {
    return true
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/helper/userAgent.js